var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_7655",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_7655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 2C11.7813 2 11.5673 2.002 11.3573 2.005L10.7413 2.022L10.4423 2.035L9.86327 2.069L9.31027 2.115C4.52527 2.579 2.57827 4.526 2.11427 9.311L2.06827 9.864L2.03427 10.443C2.02927 10.541 2.02427 10.641 2.02127 10.742L2.00427 11.358L2.00027 11.676L1.99927 12C1.99927 12.218 2.00127 12.432 2.00427 12.642L2.02127 13.258L2.03427 13.557L2.06827 14.136L2.11427 14.689C2.57827 19.474 4.52527 21.421 9.31027 21.885L9.86327 21.931L10.4423 21.965C10.5403 21.97 10.6403 21.975 10.7413 21.978L11.3573 21.995L11.9993 22L12.6413 21.995L13.2573 21.978L13.5563 21.965L14.1353 21.931L14.6883 21.885C19.4733 21.421 21.4203 19.474 21.8843 14.689L21.9303 14.136L21.9643 13.557C21.9693 13.459 21.9743 13.359 21.9773 13.258L21.9943 12.642L21.9993 12L21.9943 11.358L21.9773 10.742L21.9643 10.443L21.9303 9.864L21.8843 9.311C21.4203 4.526 19.4733 2.579 14.6883 2.115L14.1353 2.069L13.5563 2.035C13.4566 2.03014 13.357 2.0258 13.2573 2.022L12.6413 2.005L12.3233 2.001L11.9993 2Z",
    fill: "#00A266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99927 12L10.9993 14L14.9993 10",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/done-icon.fa251160a6c629b3db3dfdba2c57ce5c.svg";
export { ForwardRef as ReactComponent };